export default "__VITE_PUBLIC_ASSET__841b50f6__"